import { Column } from "../../../../core/components/Column";
import { Row } from "../../../../core/components/Row";
import { TextComponent } from "../../../../core/components/TextComponent";
import { businessName, urlBusinessName } from "../../../../core/constants/utils";
import { EmailIcon } from "../../../../core/icons/Email";
import { WhatsAppIcon } from "../../../../core/icons/WhatsApp";
import { SocialLinks } from "../components/SocialLinks";

export const Footer = () => {
	return (
		<Row
			mainAxisAlignment="center"
			className="w-full text-white mt-auto px-4 py-14 bg-black/90"
		>
			<Column className="lg:grid lg:grid-cols-2 gap-10 lg:w-[60rem]">
				{/* <article className="flex w-full items-center flex-col gap-3">
					<img
							className="w-60"
							src="/logo_horizontal.png"
							alt="Logo de Megabodas, By Sinthia Flores - Wedding Planner & Event Designer"
						/>
					<ul className="flex flex-col gap-2">
							<li className="flex items-center gap-2">
								<CalendarIcon />
								<p className="text-sm">Del 18 al 22 de Noviembre</p>
							</li>
							<li className="flex items-center gap-2">
								<LocationIcon />
								<p className="text-sm">UNJBG, Tacna, Perú</p>
							</li>
						</ul>
					</article> */}
				{/* <div/> */}
				<Column className="max-lg:items-center gap-3">
					<Column className=" font-bold max-lg:text-center font-isabel">
						<TextComponent variant="h2">MEGABODAS</TextComponent>
						<TextComponent variant="h2">By Sinthia Flores</TextComponent>
					</Column>
					<TextComponent
						variant="h5"
						className="max-lg:text-center"
					>
						Nuestra planificación, organización y diseños son puntualizados ordenadamente para completar un plan organizacional que conlleve al éxito de nuestro evento.
					</TextComponent>
				</Column>
				<Column
					className="gap-3"
					crossAxisAlignment="center"
				>
					<Column className="gap-3">
						<TextComponent
							variant="h2"
							className="max-lg:text-center font-bold font-isabel"
						>
							Contáctanos
						</TextComponent>
						<Column className="gap-2">
							<Row
								className="gap-2"
								crossAxisAlignment="center"
							>
								<WhatsAppIcon />
								<a
									href="https://wa.me/51952520583"
									target="_blank"
									rel="noopener noreferrer"
								>
									<TextComponent variant="h5">+51 952 520 583</TextComponent>
								</a>
							</Row>
							<Row
								className="gap-2"
								crossAxisAlignment="center"
							>
								<EmailIcon />
								<TextComponent variant="h5">megabodaswep@gmail.com</TextComponent>
							</Row>
						</Column>
						<SocialLinks />
						<a
							href={urlBusinessName}
							target="_blank"
							rel="noreferrer"
						>
							<TextComponent
								variant="h5"
								className="font-medium max-lg:text-center tracking-wide"
							>
								Creado con ♥️ por <span className="underline font-bold text-primarySunset">{businessName}</span>
							</TextComponent>
						</a>
					</Column>
				</Column>
			</Column>
		</Row>
	);
};
